import React from 'react';
import { graphql } from "gatsby";
import { makeStyles } from '@material-ui/styles';
import {buildBlocks} from "../../../services/builder";
import styles from './styles';

const useStyles = makeStyles(theme => styles(theme));

export const CgbFeaturedIconsInnerBlock = (props) => {
    const blocks = buildBlocks(props.innerBlocks, props.parentAttributes, props.pageContext);
    const classes = useStyles();

    return <div className={`featured-icons-inner ${props.attributes.className ? props.attributes.className : ''} ${classes.featuredIconsInner} ${classes.featuredIconsInnerTheme}`}>
            {blocks.map((block) => {
                return block;
            })}
    </div>
};

export const CgbFeaturedIconsInnerBlockFragment = graphql`
  fragment CgbFeaturedIconsInnerBlock on WpBlock {
    ... on WpCgbFeaturedIconsInnerBlock {
        name
        attributes {
            className
        }
      }
  }`;

// This is the string version of this that is used within previews and without WP prefixes
export const CgbFeaturedIconsInnerBlockPreview = `
    ... on CgbFeaturedIconsInnerBlock {
        name
        attributes {
            className
        }
    }
`;